import './art/start-menu/start-menu-art.component';
